<div class="margin-bottom">
  <lms-students-batch-create
    [group]="group"
    [tooltipText]="infoMessage"
    (studentsData)="enrollImportedStudents($event)"
  ></lms-students-batch-create>
</div>
